export const MONEY_FOR_REFERRING_TO_OTHERS = {
  PLN: 149,
  EUR: 39
};

export const MONEY_FOR_REGISTER_THROUGH_REFERRAL = {
  PLN: 99,
  EUR: 29
};
